import { FileText, Phone, Voicemail, Mail, MessageSquare, Users } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { CommunicationChannel } from "@/api/communications";

const ICON_MAP: Record<CommunicationChannel, LucideIcon> = {
  Call: Phone,
  Voicemail: Voicemail,
  Email: Mail,
  Sms: MessageSquare,
  Meeting: Users,
  WebForm: FileText,
};

export const CHANNEL_LABELS: Record<CommunicationChannel, string> = {
  Call: "Call",
  Voicemail: "Voicemail",
  Email: "Email",
  Sms: "SMS",
  Meeting: "Meeting",
  WebForm: "Web form",
};

/** Channel-specific colour token (text-* class). */
export const CHANNEL_COLOR_CLASS: Record<CommunicationChannel, string> = {
  Call: "text-gold",
  Voicemail: "text-gold-shadow",
  Email: "text-status-info",
  Sms: "text-status-success",
  Meeting: "text-status-warning",
  WebForm: "text-gray-mid",
};

/** Faint background tint for chip backgrounds. */
export const CHANNEL_BG_CLASS: Record<CommunicationChannel, string> = {
  Call: "bg-gold/10 border-gold/40",
  Voicemail: "bg-gold-shadow/10 border-gold-shadow/40",
  Email: "bg-status-info/10 border-status-info/40",
  Sms: "bg-status-success/10 border-status-success/40",
  Meeting: "bg-status-warning/10 border-status-warning/40",
  WebForm: "bg-gray-mid/10 border-gray-mid/40",
};

interface Props {
  channel: CommunicationChannel;
  size?: number;
  className?: string;
}

export function ChannelIcon({ channel, size = 16, className }: Props) {
  const Icon = ICON_MAP[channel];
  return (
    <Icon
      size={size}
      strokeWidth={1.5}
      className={className ?? CHANNEL_COLOR_CLASS[channel]}
      aria-hidden
    />
  );
}
